import { render, staticRenderFns } from "./YagiofferSelfPrAppendBox.vue?vue&type=template&id=63b70518&scoped=true"
import script from "./YagiofferSelfPrAppendBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./YagiofferSelfPrAppendBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./YagiofferSelfPrAppendBox.vue?vue&type=style&index=0&id=63b70518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b70518",
  null
  
)

export default component.exports